// @flow
import * as types from './mutation-types'
import type {OrderState} from './index'
import type {OrderSummary} from '../../../types/order-summary'

export default {
  [types.SET_ORDERS_FOR_CURRENT_FILTER]: (state: OrderState, orders: OrderSummary[]): void => {
    state.ordersForCurrentFilter = orders
  },
  [types.SET_TOTAL_NO_ORDERS_FOR_CURRENT_FILTER]: (state: OrderState, count: number): void => {
    state.totalNoOrdersForCurrentFilter = count
  },
  [types.SET_ORDERS_CURRENT_PAGE_NUMBER]: (state: OrderState, { number }: { number: number }): void => {
    state.ordersCurrentPageNumber = number
  },
  [types.SET_ORDERS_PAGE_SIZE]: (state: OrderState, number: number): void => {
    if (number <= 0) {
      return
    }
    state.ordersPageSize = number
    let noPages = Math.ceil(state.totalNoOrdersForCurrentFilter / number)
    if (state.ordersCurrentPageNumber >= noPages) {
      state.ordersCurrentPageNumber = noPages - 1
    }
  },
  [types.SET_ORDERS_ORDER_BY]: (state: OrderState, orderBy: ?string): void => {
    state.ordersOrderBy = orderBy
  },
  [types.SET_ORDERS_ORDER_DIRECTION]: (state: OrderState, orderDirection: ?string): void => {
    state.ordersOrderDirection = orderDirection
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order/mutations.js